import axios from 'axios'
import baseService from './baseService'
import printRequestData from './data/printRequest'

const printRequestService = {
  single (printRequestId) {
    const testMode = baseService.isTestMode === undefined ? true : baseService.isTestMode
    return new Promise((resolve, reject) => {
      // if (baseService.isTestMode) {
      if (testMode) {
        const printRequestIdNumber = Number(printRequestId)
        resolve(printRequestData.all.find((x) => x.id === printRequestIdNumber))
      } else {
        axios
          .post('/printRequest/get?id=' + printRequestId, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getPrintRequest (token) {
    return new Promise((resolve, reject) => {
      axios
        .get('/print/printrequest', { params: { token: token } }, baseService.defaultConfig)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response.data)
        })
    })
  },
  generatePdfWithSignature (generatePdfModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        var generatePdf = {
          signatureString: 'data:image/png;base64,...',
          printRequestAttachmentId: 1
        }
        resolve(generatePdf)
      } else {
        axios
          .post('/print/generatePdfWithSignature', generatePdfModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  }
}

export default printRequestService
